module.exports = __webpack_public_path__ + "img/2.ef9e40a0.jpg";